import { formatAccount } from '../../helpers';
import { AddressZero } from '@ethersproject/constants';
import useUserCreatedReferral from '../../hooks/referral/useUserCreatedReferral';
import Avatar from '../Avatar';
import clsx from 'clsx';

type UserReferralProps = {
    userAddress?: string | null;
    className?: string;
};

const UserReferral: React.FC<UserReferralProps> = ({ userAddress, className }) => {
    const { userCreatedReferral } = useUserCreatedReferral(userAddress);

    return (
        <div className={clsx('user-referral', className)}>
            <Avatar userAddress={userAddress} />
            <div>
                {userCreatedReferral && (
                    <span className='referral-code'>{userCreatedReferral}</span>
                )}
                <span className='user-address'>
                    {formatAccount(userAddress || AddressZero)}
                </span>
            </div>
        </div>
    );
};

export default UserReferral;
